import { apiClient } from '@/api/api'
import type { AxiosResponse } from 'axios'
import type { ClaimProfileRewardResponse, ProfileData, UserProfileDataResponse } from '@/types/profile-data'

// export const getProfileData = (): Promise<AxiosResponse<ProfileData>> => {
//   // TODO: Replace with real API endpoint
//   return new Promise((resolve) => {
//     setTimeout(() => {
//       resolve({
//         data: {
//           level: {
//             name: 'Новичок',
//             currentProgress: 45
//           },
//           progressBar: {
//             sections: [
//               {
//                 id: 'section-1',
//                 isCompleted: true
//               },
//               {
//                 id: 'section-2',
//                 isCompleted: false
//               },
//               {
//                 id: 'section-3',
//                 isCompleted: false
//               }
//             ]
//           },
//           styles: {
//             hasCompletedSurvey: false,
//             previews: []
//           },
//           sizes: {
//             tags: [
//               {
//                 category: 'Верх',
//                 size: null
//               },
//               {
//                 category: 'Низ',
//                 size: null
//               },
//               {
//                 category: 'Обувь',
//                 size: null
//               }
//             ]
//           },
//           nextLevelRequirements: [
//             {
//               id: 'req-1',
//               icon: 'pi pi-user',
//               text: 'Заполнить персональные данные',
//               progress: 60,
//               status: 'in_progress'
//             },
//             {
//               id: 'req-2',
//               icon: 'pi pi-palette',
//               text: 'Определить стиль',
//               progress: 0,
//               status: 'not_started'
//             },
//             {
//               id: 'req-3',
//               icon: 'pi pi-check',
//               text: 'Заполнить размеры',
//               progress: 0,
//               status: 'not_started'
//             },
//             {
//               id: 'req-4',
//               icon: 'pi pi-heart',
//               text: 'Добавить в избранное 5 товаров',
//               progress: 40,
//               status: 'in_progress'
//             }
//           ]
//         }
//       } as AxiosResponse<ProfileData>)
//     }, 300)
//   })
// }

// Вариант с пройденным опросом (для тестирования)
// Раскомментируйте этот вариант и закомментируйте выше, чтобы протестировать состояние с пройденным опросом

// DEPRECATED: This function is not used anywhere in the codebase.
// All code should use getUserProfileData() instead.
export const getProfileData = (): Promise<AxiosResponse<ProfileData>> => {
  throw new Error(
    'getProfileData() is deprecated and no longer supported. ' +
    'Please use getUserProfileData() instead.'
  )
}

export const getUserProfileData = (): Promise<AxiosResponse<UserProfileDataResponse>> => {
  return apiClient.get<UserProfileDataResponse>('/user-profile/profile-data')
}

/** BE-132 — claims the reward of a reached level; 404 unknown / not reached, 409 already claimed. */
export const claimProfileReward = (level: string): Promise<AxiosResponse<ClaimProfileRewardResponse>> => {
  return apiClient.post<ClaimProfileRewardResponse>(`/user-profile/rewards/${encodeURIComponent(level)}/claim`)
}
